/* eslint-disable react/display-name */
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Typography, Form, Button, message } from "antd";
import LoginTemplate from "../Login/LoginTemplate";
import { authService } from "../../../configs/constants";
import axios from "axios";
import { useForm } from "react-hook-form";
import OtpInput from "react-otp-input";

const { Text, Title } = Typography;

const OTP = () => {
  const [loading, setLoading] = useState(false);

  const [otp, setOTP] = useState<any>();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();
  const numInputs = 4;

  const handleChange = (values) => {
    setOTP(values);
  };

  const resendCode = async () => {
    setLoading(true);
    const headers = {
      application: 1,
    };

    const postJson = {
      email: location?.["state"]?.email,
      logintype: "email",
      usertype: location?.["state"]?.usertype,
    };
    const url = `${authService}/user/signup`;
    try {
      const response = await axios.post(url, postJson, { headers: headers });
      setLoading(false);
      message.success("OTP sent successfully!");
    } catch (e) {
      // refReCaptcha.current.execute();
      setLoading(false);
      const { response } = e;
      console.log("response", response);

      message.error(response?.data?.error);
    }
  };

  const onFinish = async () => {
    setLoading(true);
    const headers = {
      application: 1,
    };

    const postJson = {
      email: location?.["state"]?.email,
      userid: location?.["state"]?.userid,
      otp: otp,
      usertype: location?.["state"]?.usertype,
    };
    const url = `${authService}/user/verifyOtp`;
    try {
      const response = await axios.post(url, postJson, { headers: headers });

      setLoading(false);
      message.success("OTP verified successfully! You can create password now.");

      navigate("/create-password", {
        state: {
          userid: response?.data?.result?.id,
          usertype: location?.["state"]?.usertype,
        },
      });
    } catch (e) {
      setLoading(false);

      const { response } = e;

      console.log("error", response?.data?.error);

      message.error(response?.data?.error);
    }
  };

  return (
    <LoginTemplate load={loading}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Text className="defaultFont fontWeight600 green-color">Enter OTP</Text>
        </Col>
        <Col span={24}>
          <Form name="normal_login" className="forgot-password-form text-left" onFinish={handleSubmit(onFinish)}>
            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={numInputs}
              inputType="tel"
              renderInput={(props) => (
                <div className="inputStyle">
                  <input {...props} />
                </div>
              )}
            />

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                size="large"
                disabled={otp?.length < numInputs || otp?.length == undefined}
              >
                Submit
              </Button>
            </Form.Item>
            {/* <ReCaptcha
              ref={refReCaptcha}
              action="main"
              sitekey={SITEKEY}
              verifyCallback={verifyCallback}
            /> */}
          </Form>
        </Col>
        <Col span={24}>
          <Title level={5} className="text-center">
            Did not receive an OTP?{" "}
            <Button type="link" className="p-0 defaultFont" onClick={resendCode}>
              Click to Resend.
            </Button>
          </Title>
        </Col>
      </Row>
    </LoginTemplate>
  );
};

export default OTP;
